<template>
    <div class="responsive-table">
        <table>
            <tbody>
                <tr>
                    <td class="right">
                        <i class="material-icons left">email</i>
                    </td>
                    <td class="right">
                        e-mail
                    </td>
                    <td>
                        {{ usu.email }}
                        <div style="color:red;">
                            *Para atualizar o e-mail, utilize a
                            <a href="https://intranet.ufrj.br/atualizacao-email"
                                >Intranet</a
                            >
                            <br />
                            (para as atualizações ficarem visíveis, é necessário
                            se deslogar e logar novamente).
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="right">
                        <i class="material-icons left">person_pin</i>
                    </td>
                    <td class="right">
                        Nome Social
                    </td>
                    <td>
                        {{ usu.nome_social }}
                    </td>
                </tr>
                <tr>
                    <td class="right">
                        <i class="material-icons left">credit_card</i>
                    </td>
                    <td class="right">
                        CPF
                    </td>
                    <td>{{ usu.cpf }}</td>
                </tr>
				<tr v-if="aluno">
                    <td class="right">
                        <i class="material-icons left">chrome_reader_mode</i>
                    </td>
                    <td class="right">
                        DRE
                    </td>
                    <td>{{ aluno.sira }}</td>
					<tr v-if="aluno">
						<td class="right">
							<i class="material-icons left">school</i>
						</td>
						<td class="right">
							Curso
						</td>
						<td>
							{{aluno.curso}}
						</td>
					</tr>
                </tr>
                <tr v-else>
                    <td class="right">
                        <i class="material-icons left">chrome_reader_mode</i>
                    </td>
                    <td class="right">
                        Cargo
                    </td>
                    <td>    
                        <template v-for="(perfil, index) in perfisUsu">
                            <template v-if="(usu.perfil & index) && (perfil[0] == 'Técnico' || perfil[0] == 'Docente')">
                                {{ perfil[0] }}<br>
                            </template>   
                         </template>
                    </td>
                </tr>
				<!-- <tr>
                    <td class="right">
                        <i class="material-icons left">view_headline</i>
                    </td>
                    <td class="right">
                        Lattes
                    </td>
                    <td v-if="edit" style="margin: 0 !important; padding: 0 !important">
						http://lattes.cnpq.br/
						<div class="input-field inline" style="margin: 0 !important; padding: 0 !important">
							<input
							id="lattes"
							name="lattes"
							type="text"
							class="validate"
							v-model="usu.lattes"
							placeholder='* Lattes'
							title='Insira o ID de 16 dígitos do seu currículo Lattes'
							data-toggle ='tooltip'
							maxlength="16"
							minlength="16"
							pattern="[0-9]+"
							v-bind:class="{ 'red-text': (usu.lattes && usu.lattes.length != 16), 'green-text': (usu.lattes && usu.lattes.length == 16) }"/>
						</div>
					</td>
					<td v-else> 
						<a v-if='usu.lattes' style='text-transform:lowercase' :href="'http://lattes.cnpq.br/' + usu.lattes" target='_blank'>http://lattes.cnpq.br/{{usu.lattes}}</a>
					</td>
                </tr> -->
                <tr>
                    <td class="right">
                        <i class="material-icons left">account_balance</i>
                    </td>
                    <td class="right">
                        Centro
                    </td>
                    <td>
                        <div v-if="!edit && uni.centro">
                            {{ uni.centro.nome }} 
                        </div>
                        <div v-if="edit">
                            <select
                                name="centro"
                                v-model="centroSelected"
                                v-on:change="verifyUnidades"
                                required
                                class="browser-default select_sec"
                            >
                                <option value="" disabled selected
                                    >Escolha o centro</option
                                >
                                <option
                                    v-for="centro in this.cens"
                                    :value="centro.id"
                                    >{{ centro.nome }}</option
                                >
                            </select>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="right">
                        <i class="material-icons left">extension</i>
                    </td>
                    <td class="right">
                        Unidade
                    </td>
                    <td>
                        <div v-if="!edit && uni">
                            {{ uni.nome }}
                        </div>
                        <div v-if="edit">
                            <select
                                name="unidade"
                                v-model="uni.id"
                                required
                                class="browser-default select_sec"
                            >
                                <option value="" disabled selected
                                    >Escolha a unidade</option
                                >
                                <option
                                    v-for="unidade in this.unis"
                                    :value="unidade.id"
                                    >{{ unidade.nome }}</option
                                >
                            </select>
                        </div>
                    </td>
                </tr>
                <tr v-if='!is_aluno'>
                    <td class="right">
                        <i class="material-icons left">place</i>
                    </td>
                    <td class="right">
                        Localização
                    </td>
					<td v-if='loc.id'>
                        {{ loc.nome.trim() }} - {{ loc.codigo }}
					</td>
					<td v-else>
                    </td>
				</tr>
				<tr>
                    <td class="right">
                        <i class="material-icons left">portrait</i>
                    </td>
                    <td class="right">
                        Perfil
                    </td>
                    <td>
                        <div v-for="(perfil, index) in perfisUsu">
                            <span
                                v-if="usu.perfil & index"
                                class="new badge grey lighten-1"
                                data-badge-caption=""
                            >
                                {{ perfil[0] }}
                            </span>
                        </div>
                    </td>
                </tr>
				<tr v-if="papel">
                    <td class="right">
                        <i class="material-icons left yellow-text text-darken-4">warning</i>
                    </td>
                    <td class="right">
                        Aviso
                    </td>
                    <td>
                        <span class="label-info-baixo-destaque label-info-nao-encontrada">
                            Você está usando a funcionalidade de troca de papel, por isso está visualizando o sistema como esse usuário... <br>Caso queira sair é só apertar o botão "SAIR DO PAPEL".
                        </span>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td v-if="edit" class="right">
                        <button type="submit" class="btn">
                            <i class="material-icons left">save</i>Salvar
                            Informações
                        </button>
                    </td>
                    <td v-else>
                        <a
                            href="/dados/true"
                            class="waves-effect waves-light btn-small right indigo darken-4"
                            >Atualizar Informações</a
                        >
                    </td>
					<td v-if="!edit && papel">
                        <a href='/usuario/sair/'
                           class="waves-effect waves-light btn-small right red">
                            Sair do Papel
                            <i class="material-icons left">exit_to_app</i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

export default {
    name: "VueDadosForm",
    props: ["usuario", "unidade", "centro", "localizacao", "edit", "centros", "perfis", "bolsista", "is_aluno", "papel"],
    data() {
        return {
            usu: JSON.parse(this.usuario),
            uni: JSON.parse(this.unidade),
			aluno: this.bolsista? JSON.parse(this.bolsista) : null,
            editar: this.edit,
            perfisUsu: JSON.parse(this.perfis),
            cens: JSON.parse(this.centros),
			loc: JSON.parse(this.localizacao),
            unis: null,
            centroSelected: JSON.parse(this.centro).id
        };
    },
    methods: {
        verifyUnidades: function() {
            if (this.centroSelected) 
                this.$http
                    .get("/api/centros/" + this.centroSelected + "/unidade")
                    .then(req => {
                        this.unis = req.body;
                    });
        }
    },
    mounted: function() {
		this.verifyUnidades();
		if (!this.centroSelected)
			this.centroSelected = '';
		if (!this.uni.id)
			this.uni.id = '';
       
    }
};
</script>
